import { Hidden } from '@mui/material'
import Image from 'next/image'
import { IEnum_Componentcontentcontentwriter_Writeroption } from 'src/graphql/generated/hooks'
import { useContentWriterInformation } from 'src/hooks/useContentWriterInformation'
import type { NormalizedWriter } from 'src/utils/normalizeContentWriters'
import { normalizeWritersList } from 'src/utils/normalizeContentWriters'

import { CompatibleLink } from '../CompatibleLink/CompatibleLink'
import { COMPACT_LIST_AUTHOR_NAME_P_CLASS, ContentWritersByline } from '../ContentWritersByline/ContentWritersByline'

interface ContentWriterProps {
  writer: NormalizedWriter | NormalizedWriter[] | null | undefined
}

const ContentWriterSingle: React.FC<{ writer: NormalizedWriter }> = ({ writer }) => {
  const info = useContentWriterInformation(writer)
  if (!info) {
    return null
  }
  const { name, option, logo, url } = info

  const divContent = (
    <>
      {option !== IEnum_Componentcontentcontentwriter_Writeroption.Vendor && (
        <Image src={logo} alt="" className="w-[26px] h-[26px] rounded-[13px]" width={26} height={26} priority />
      )}
      {option === IEnum_Componentcontentcontentwriter_Writeroption.Vendor && (
        <div className="rounded-[3px] bg-clouds p-[2px]">
          <Image src={logo} alt="" className="w-[26px] h-[26px] rounded-[13px]" priority width={26} height={26} />
        </div>
      )}
      <Hidden mdDown>
        <p className={COMPACT_LIST_AUTHOR_NAME_P_CLASS}>{name}</p>
      </Hidden>
    </>
  )
  return url ? (
    <CompatibleLink href={url} className="flex flex-row items-center">
      {divContent}
    </CompatibleLink>
  ) : (
    <div className="flex flex-row items-center">{divContent}</div>
  )
}

export const ContentWriter: React.FC<ContentWriterProps> = ({ writer }) => {
  const writers = normalizeWritersList(writer)
  if (writers.length === 0) {
    return null
  }
  if (writers.length === 1) {
    return <ContentWriterSingle writer={writers[0]} />
  }
  return <ContentWritersByline writers={writers} variant="compact" />
}
